import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Directive({
  selector: '[appDnd]'
})
export class DndDirective {
  @Input() allowedExtensions: Array<string> = [];
  @Output() private filesChangeEmitter: EventEmitter<File[]> = new EventEmitter();
  @Output() private filesInvalidEmitter: EventEmitter<File[]> = new EventEmitter();
  @Output() private dragFileEmitter: EventEmitter<boolean> = new EventEmitter();

  constructor() {
  }

  @HostListener('dragover', ['$event'])
  public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    const typesOK = this.isTypeValid( evt.dataTransfer.types );

    if ( typesOK ) {
      evt.dataTransfer.effectAllowed = 'copyLink';
      this.dragFileEmitter.emit(true);
    } else {
      evt.dataTransfer.effectAllowed = 'none';
      evt.dataTransfer.dropEffect = 'none';
      this.dragFileEmitter.emit(false);
    }
  }

  @HostListener('drop', ['$event'])
  public onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    const typesOK = this.isTypeValid( evt.dataTransfer.types );

    if ( typesOK ) {
      this.dragFileEmitter.emit(true);
      const files = evt.dataTransfer.files;
      const valid_files: Array<File> = [];
      const invalid_files: Array<File> = [];
      if (files.length > 0) {
        for (const file of files) {
          const ext = file.name.split('.')[file.name.split('.').length - 1];
          if (this.allowedExtensions.lastIndexOf(ext) !== -1) {
            valid_files.push(file);
          } else {
            invalid_files.push(file);
          }
        }
        this.filesChangeEmitter.emit(valid_files);
        this.filesInvalidEmitter.emit(invalid_files);
      }
    }
  }

  public isTypeValid( types: string ): boolean {
    for ( const t of types ) {
      if ( t === 'Files' ) {
        return true;
      }
    }
    return false;
  }
}
